import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Subscription } from 'rxjs';
import { AuthorizationService } from '../../services/authorization.service';
import { LandingPageStateService } from '../../services/landing-page-state.service';
import { SignerVerificationService } from '../../services/altinn/signer-verification.service';

@Component({
  selector: 'landing-page-user-badge',
  templateUrl: './landing-page-user-badge.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class LandingPageUserBadgeComponent implements OnInit, OnDestroy {

  loggedInName: string | null = null;
  developerOrganizationName: string | null = null;

  private applicationId = '';
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly oauthService: OAuthService,
    private readonly authorizationService: AuthorizationService,
    private readonly landingPageStateService: LandingPageStateService,
    private readonly signerVerificationService: SignerVerificationService,
  ) {
  }

  get isLoggedIn(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  ngOnInit(): void {
    // The badge renders on every step, but only the details step asks for the verification. Ask
    // here too, or the banner shows a nameless "Logg ut" everywhere else. ensureLoaded is
    // idempotent per application id, so this costs no extra round trip.
    this.subscriptions.add(this.landingPageStateService.application$
      .subscribe(application => {
        this.applicationId = application?.applicationID ?? '';
        this.signerVerificationService.ensureLoaded(this.applicationId);
      }));

    // The name comes from the Altinn party lookup, so it only appears once the signer has been
    // verified. The logout button does not depend on it.
    this.subscriptions.add(this.signerVerificationService.state$
      .subscribe(state => {
        this.loggedInName = state.status === 'loaded' ? state.verification.loggedInName : null;
        this.developerOrganizationName = state.status === 'loaded' ? (state.verification.developerOrganizationName || null) : null;
      }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  logOut(): void {
    this.authorizationService.logOut(this.applicationId);
  }
}
